
// import organizationSerivce from '@/modules/Organization/service.js'

export default {
    namespaced: true,
    state: {
        modules: {},
        employeeList: [],
        timeClockUsers: {
            admins: [],
            employees: [],
        },
        selectedRange: 'thisWeek',
        currentOrganization: {},
    },
    getters: {
        getSelectedRange(state) {
            return state.selectedRange;
        },
        employeeList(state) {
            return state.employeeList;
        },
        getTimeClockUsers(state) {
            return state.timeClockUsers;
        },
    },
    actions: {
        setSelectedRange({ commit }, payload) {
            commit('setSelectedRange', payload);
        },
        setEmployeeList({ commit }, payload) {
            commit('setEmployeeList', payload);
        },
        setTimeClockAdmins({ commit }, payload) {
            commit('setTimeClockAdmins', payload);
        },
        setTimeClockEmployees({ commit }, payload) {
            commit('setTimeClockEmployees', payload);
        }
    },
    mutations: {
        setSelectedRange(state, payload) {
            state.selectedRange = payload;
        },
        setEmployeeList(state, payload) {
            state.employeeList = payload;
        },
        setTimeClockAdmins(state, payload) {
            state.timeClockUsers.admins = payload;
        },
        setTimeClockEmployees(state, payload) {
            state.timeClockUsers.employees = payload;
        },
        initOrganization(state, payload) {
            state.currentOrganization = payload
          },
    }
}